import React from 'react'
import { colors, PixelTooltip } from 'pixel-base'
import { DeliveryRisk } from 'client/../decl'
import { getDeliveryOutlook } from './deliveryOutlook'

interface DeliveryRiskCellProps {
  risk: DeliveryRisk | null | undefined
}

const cellStyle: React.CSSProperties = {
  display: 'inline',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
}

const separatorStyle: React.CSSProperties = {
  color: colors.secondary,
  fontWeight: 400,
}

const unavailableStyle: React.CSSProperties = {
  color: colors.secondary,
  fontSize: '12px',
  lineHeight: 1.2,
}

const tooltipLineStyle: React.CSSProperties = {
  display: 'block',
  textAlign: 'left',
}

/**
 * Ultra-compact outlook: `D89% · R11%`
 * No bar, badge, tag, icon, hook, or network.
 */
const DeliveryRiskCell: React.FC<DeliveryRiskCellProps> = ({ risk }) => {
  const outlook = getDeliveryOutlook(risk)

  if (!outlook.available) {
    return (
      <span
        data-testid="delivery-outlook-unavailable"
        aria-label="Delivery outlook not available"
        style={unavailableStyle}
      >
        —
      </span>
    )
  }

  return (
    <PixelTooltip
      style={{ width: 'auto' }}
      tooltipText={
        <span data-testid="delivery-outlook-tooltip-body">
          {outlook.tooltipLines.map((line) => (
            <span key={line} style={tooltipLineStyle}>
              {line}
            </span>
          ))}
        </span>
      }
    >
      <span
        tabIndex={0}
        data-testid="delivery-outlook"
        aria-label={`${outlook.deliveryPercent}% delivery, ${outlook.returnPercent}% return`}
        style={cellStyle}
      >
        <span style={{ color: colors.success }}>
          D{outlook.deliveryPercent}%
        </span>
        <span aria-hidden="true" style={separatorStyle}>
          {' · '}
        </span>
        <span style={{ color: colors.danger }}>R{outlook.returnPercent}%</span>
      </span>
    </PixelTooltip>
  )
}

export default DeliveryRiskCell
